import { Component, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReportParamsComponent } from '../../../../../../../shared/tokens/report-params';

@Component({
  selector: 'adf-fixed-contents-params',
  imports: [FormsModule],
  templateUrl: './fixed-contents-params.component.html',
  styleUrls: ['./fixed-contents-params.component.scss'],
})
export class FixedContentsParamsComponent implements ReportParamsComponent {
  variables: Record<string, unknown> = {
    IsWBSColumnsVisible: false,
    IsWeightPerUnitVisible: false,
    IsComment2Visible: false,
    IsOutEngOriginVisible: false,
    IsICEngOriginVisible: false,
    IsExternalSuppliesColumnsVisible: false,
    IsIntraSuppliesOriginVisible: false,
    IsMcSurchargesColumnsVisible: false,
  };
  selectionChanged?: (variables: Record<string, unknown>) => void;

  private _ctrlHeld = false;
  private _snapshot: Record<string, unknown> | null = null;

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Control' && !this._ctrlHeld) {
      this._ctrlHeld = true;
      this._snapshot = { ...this.variables };
    }
  }

  @HostListener('document:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Control') {
      this._ctrlHeld = false;
      if (this._snapshot && this._hasChanged(this._snapshot)) {
        this.selectionChanged?.(this.variables);
      }
      this._snapshot = null;
    }
  }

  onCheckboxChange(): void {
    if (this._ctrlHeld) return;
    this.selectionChanged?.(this.variables);
  }

  private _hasChanged(snapshot: Record<string, unknown>): boolean {
    return Object.keys(this.variables).some((k) => this.variables[k] !== snapshot[k]);
  }
}
